import React from "react";
import { Stack, Typography } from "@mui/material";
import { getUrlHost } from "../../../Infrastructure/Helpers/StringHelper";
import { TEXT_ELLIPSIS } from "../../Shared/styles";

export function LinkoutReply({
    linkoutUrl,
    invertColor,
}: {
    linkoutUrl: string;
    invertColor?: boolean;
}) {
    return (
        <Stack
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
            flex={1}
        >
            <Typography fontSize="12px">&#128279; &nbsp;</Typography>
            <Stack
                style={{
                    minWidth: 0,
                    ...TEXT_ELLIPSIS,
                }}
                flex="1"
                alignItems="flex-start"
            >
                <Typography
                    style={{
                        fontSize: "12px",
                        color: invertColor ? "#fff" : "inherit",
                    }}
                >
                    {getUrlHost(linkoutUrl)}
                </Typography>
            </Stack>
        </Stack>
    );
}
